import { createRef } from 'react'
import { CustomRouteObject } from 'react-router-dom'

import { routeNamesPaths } from '@shared/constants'

export const DownloadPresentationPageRouter: CustomRouteObject = {
  path: routeNamesPaths.downloadPresentation,
  lazy: async () => {
    const { DownloadPresentation } = await import('./ui')

    return {
      Component: DownloadPresentation,
    }
  },
  nodeRef: createRef(),
}
